jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

// ─────────────────────────────────────────────────────────────────────────────
// FK Debug + Blank-grid recovery
// ─────────────────────────────────────────────────────────────────────────────
(function($) {
  'use strict';

  var fkSortClicked = false;  // true between sort click and currency:update

  // ── Sort click ──────────────────────────────────────────────────────────────
  $(document).on('click', '[data-sortby-item]', function() {
    fkSortClicked = true;
    var val = jQuery_T4NT(this).data('value');
    console.log('[FK] Sort clicked:', val);
  });

  // ── After every AJAX reload (sort / filter / load-more) ────────────────────
  $('body').on('currency:update', function() {
    var products = document.querySelectorAll('.t4s-product').length;
    var sortParam = new URLSearchParams(window.location.search).get('sort_by') || '';
    console.log('[FK] currency:update | products:', products, '| sort:', sortParam, '| sortClicked:', fkSortClicked);

    // ── Blank-grid recovery ──────────────────────────────────────────────────
    // If a sort was just clicked and the grid came back empty, the AJAX
    // inserted nothing (or something wiped it). A full-page navigation to the
    // current URL will render the correct products server-side.
    if (fkSortClicked && products === 0) {
      fkSortClicked = false;
      console.log('[FK] Blank grid detected after sort – navigating to reload:', window.location.href);
      // Small delay so the URL is already updated by pushState
      setTimeout(function() {
        window.location.href = window.location.href;
      }, 100);
      return;
    }

    fkSortClicked = false;

    // ── Check again after 400ms in case something clears the grid later ──────
    if (products > 0 && sortParam) {
      setTimeout(function() {
        var productsLater = document.querySelectorAll('.t4s-product').length;
        if (productsLater === 0) {
          console.warn('[FK] Products disappeared 400ms after currency:update – reloading');
          window.location.href = window.location.href;
        }
      }, 400);
    }
  });

  // ── Page load ────────────────────────────────────────────────────────────
  $(document).ready(function() {
    fkUpdateYarnFilter();
  });

  // ── Yarn sub-filter update after every AJAX navigation ────────────────────
  $('body').on('currency:update', function() {
    fkUpdateYarnFilter();
  });

})(jQuery_T4NT);

// ─────────────────────────────────────────────────────────────────────────────
// FK Yarn sub-filter: show/hide checkboxes + sidebar based on URL
// ─────────────────────────────────────────────────────────────────────────────
(function() {
  // Dedicated collection handles for each yarn type
  var YARN_HANDLES = [
    'athena',
    'alpaca-silk-cashmere',
    'highland-wool',
    'mohair-silk',
    'fluffy-suri',
    'pure-wool',
    'dk-alpaca-silk-cashmere',
    'elder'
  ];

  function fkUpdateYarnFilter() {
    var nav = document.getElementById('fk-yarn-sub-nav');
    if (!nav) return;

    var path = window.location.pathname.toLowerCase().replace(/\/$/, '');

    // Are we on the /collections/all/Yarn page OR a dedicated yarn collection?
    var onYarnPage  = path === '/collections/all/yarn' || path.includes('/collections/all/yarn/');
    var activeHandle = null;

    YARN_HANDLES.forEach(function(h) {
      if (path === '/collections/' + h) {
        onYarnPage   = true;
        activeHandle = h;
      }
    });

    if (onYarnPage) {
      nav.classList.add('fk-visible');

      nav.querySelectorAll('.fk-yarn-sub-btn').forEach(function(btn) {
        var btnHandle = btn.getAttribute('data-yarn-handle');
        if (btnHandle === activeHandle) {
          btn.classList.add('is-active');
          // Clicking an active button goes back to all-yarn
          btn.setAttribute('href', '/collections/all/Yarn');
        } else {
          btn.classList.remove('is-active');
          btn.setAttribute('href', '/collections/' + btnHandle);
        }
      });
    } else {
      nav.classList.remove('fk-visible');
    }
  }

  // Make available to the jQuery block above
  window.fkUpdateYarnFilter = fkUpdateYarnFilter;

  // Force real page navigation on yarn sub-filter clicks (bypasses NTAJAX interception)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('#fk-yarn-sub-nav .fk-yarn-sub-btn');
    if (!btn) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    window.location.assign(btn.getAttribute('href'));
  }, true);
})();

// ─────────────────────────────────────────────────────────────────────────────
// FK Dye-to-order: yarn products can be bought "dye-to-order" when stock is short
//   - Liquid (snippets/product-form.liquid) renders, inside each yarn product
//     form: a [data-fk-dye] banner, a disabled hidden input
//     properties[Order type], and data-fk-label-* on the ATC text span.
//   - When the wanted quantity exceeds ready-to-ship stock we: show the banner,
//     enable the hidden property (so the cart line is flagged dye-to-order),
//     and swap the button label. Otherwise we hide/disable/restore.
//   - Requires the yarn variants to have inventory policy = CONTINUE so Shopify
//     accepts the out-of-stock add to cart.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  'use strict';

  var CSS =
    '.fk-dye{width:100%;margin:0 0 12px;padding:10px 12px;border:1px solid #d9c8a6;' +
    'background:#faf5ea;border-radius:6px;font-size:13px;line-height:1.45;color:#5b4a2f;box-sizing:border-box}' +
    '.fk-dye[hidden]{display:none!important}' +
    '.fk-dye__msg{display:block}' +
    '.fk-dye-mode .t4s-vipps-payment-row{display:none!important}';

  function injectCss() {
    if (document.getElementById('fk-dye-css')) return;
    var s = document.createElement('style');
    s.id = 'fk-dye-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function qtyOf(form) {
    var i = form.querySelector('[data-quantity-value], input[name="quantity"]');
    var n = i ? parseInt(i.value, 10) : 1;
    return (isNaN(n) || n < 1) ? 1 : n;
  }

  function sync(form) {
    var wrap = form.querySelector('[data-fk-dye]');
    if (!wrap) return;

    var readyQty = parseInt(wrap.getAttribute('data-ready-qty'), 10);
    if (isNaN(readyQty) || readyQty < 0) readyQty = 0;
    var lead = wrap.getAttribute('data-lead-time') || '2 - 3 weeks';
    var want = qtyOf(form);
    var dye = want > readyQty;

    wrap.hidden = !dye;
    form.classList.toggle('fk-dye-mode', dye);

    var prop = form.querySelector('[data-fk-dye-prop]');
    if (prop) prop.disabled = !dye;

    var msg = wrap.querySelector('[data-fk-dye-msg]');
    if (msg) {
      msg.textContent = readyQty > 0
        ? 'Only ' + readyQty + ' ready to ship right now — the rest is made as dye-to-order (ready to ship in ' + lead + ').'
        : 'Currently out of stock, but available as dye-to-order! (ready to ship in ' + lead + ')';
    }

    var atc = form.querySelector('[data-fk-atc-text], .t4s-btn-atc_text');
    if (atc) {
      var ready = atc.getAttribute('data-fk-label-ready') || 'Add to cart';
      var dyeLabel = atc.getAttribute('data-fk-label-dye') || 'Add to cart – dye to order';
      var target = dye ? dyeLabel : ready;
      if ((atc.textContent || '').trim() !== target) atc.textContent = target;
    }

    // Let the customer raise quantity past ready stock to opt into dye-to-order.
    var qi = form.querySelector('[data-quantity-value], input[name="quantity"]');
    if (qi && readyQty > 0) qi.setAttribute('max', '9999');
  }

  function initForm(form) {
    if (form.__fkDyeInit || !form.querySelector('[data-fk-dye]')) return;
    form.__fkDyeInit = true;

    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t && (t.matches('[data-quantity-value]') || t.name === 'quantity')) sync(form);
    });
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.matches('[data-quantity-value]') || t.name === 'quantity')) sync(form);
    });
    // +/- steppers change the value programmatically (no input event) — re-check next frame
    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-quantity-selector]')) requestAnimationFrame(function () { sync(form); });
    });

    sync(form);
  }

  function initAll() {
    injectCss();
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
    // re-assert on already-initialised forms (theme may reset button text)
    for (var j = 0; j < forms.length; j++) if (forms[j].__fkDyeInit) sync(forms[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', function () { setTimeout(initAll, 300); });

  var $t = window.jQuery_T4NT || window.jQuery;
  if ($t) {
    $t(document).on('variant:changed', function () { setTimeout(initAll, 60); });
    $t(document).on('cart:updated modalt4s:closed', function () { setTimeout(initAll, 60); });
  }
})();
